export function shouldShowAlert(alertDate: Date): boolean {
  const today = new Date();
  return today > alertDate;
}
